export default "__VITE_PUBLIC_ASSET__a084e94c__"